// The core build plus the eight languages named below, instead of the full
// build with its ~190 languages: the only reader is Quill's syntax module
// (window.hljs.highlightAuto), whose candidates were already limited to this
// list by `configure`, so the output is the same and 1 MB leaves the bundle.
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript'; // js, jsx
import bash from 'highlight.js/lib/languages/bash'; // sh
import xml from 'highlight.js/lib/languages/xml'; // html
import scss from 'highlight.js/lib/languages/scss';
import css from 'highlight.js/lib/languages/css';
import json from 'highlight.js/lib/languages/json';
import 'highlight.js/styles/atom-one-dark-reasonable.css';

// ----------------------------------------------------------------------

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('bash', bash);
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('scss', scss);
hljs.registerLanguage('css', css);
hljs.registerLanguage('json', json);

hljs.configure({
  languages: ['javascript', 'jsx', 'sh', 'bash', 'html', 'scss', 'css', 'json']
});

if (typeof window !== 'undefined') {
  window.hljs = hljs;
}
